module.exports = __webpack_public_path__ + "img/b9ac3a978d23457e6d240ad279952545.svg";